import { useCallback } from 'react';
import { Team } from 'api/models';
import { Action, EventType, ObjectType } from 'api/pushes';
import { AccountSocketData } from 'api/pushes/models';
import { logger } from 'services';
import { addTeam, deleteTeam, updateTeam } from 'utils/idb-utils';
import { useAccountWsUpdates } from '../use-account-ws-updates';

export const useAccountSettingsTeamsWsUpdates = (): void => {
  const handleTeamAdd = useCallback(
    async (socketData: AccountSocketData<Team>) => {
      addTeam({ ...socketData?.data, accountLevelTeam: true }).catch((err) => {
        logger.error(
          'Error occured while inserting new team in indexedDB in settings page',
          err,
        );
      });
    },
    [],
  );

  const handleTeamUpdate = useCallback(
    async (socketData: AccountSocketData<Team>) => {
      updateTeam(socketData?.data).catch((err) => {
        logger.error(
          'Error occured while updating new team in indexedDB in settings page',
          err,
        );
      });
    },
    [],
  );

  const handleTeamDelete = useCallback(
    async (socketData: AccountSocketData<Team>) => {
      await deleteTeam(socketData?.data?.teamId).catch((err) => {
        logger.error(
          'Error occured while deleting new team in indexedDB in settings page',
          err,
        );
      });
    },
    [],
  );

  useAccountWsUpdates(handleTeamAdd, EventType(Action.Create, ObjectType.Team));
  useAccountWsUpdates(
    handleTeamUpdate,
    EventType(Action.Update, ObjectType.Team),
  );
  useAccountWsUpdates(
    handleTeamDelete,
    EventType(Action.Delete, ObjectType.Team),
  );
};
